import React from 'react'
import { Button, ThemeProvider, Level, UIManager, ErrorBoundary, Toaster } from '@deseretbook/react-ui'
import { usePopup } from '@deseretbook/react-utils'
import CartSidebar from './CartSidebar'


UIManager.injectGlobal()

/**
 * Cart Button
 * @returns {function} Component
 */
const CartButton = ({ count, orderNumber }) => {
  const [totalQuantity, setTotalQuantity] = React.useState(count)
  const popup = usePopup()

  /**
   * Opens the sidebar.
   */
  const openSidebar = () => {
    if (window.CustomerSupport) {
      window.CustomerSupport.closeChat()
      window.CustomerSupport.hideChatBubble()
    }

    popup.open()
  }

  /**
   * Closes the sidebar.
   */
  const closeSidebar = () => {
    if (window.CustomerSupport && popup.isOpen) {
      window.CustomerSupport.showChatBubble()
    }

    popup.close()
  }

  return (
    <ThemeProvider>
      <React.Fragment>
        <Toaster />
        <Level>
          <Level.Right>
            <Level.Item>
              <Button
                type="button"
                color="secondary"
                icon="shoppingCart"
                {...popup.triggerProps}
                onClick={openSidebar}
              >
                {totalQuantity || 0} Item{totalQuantity !== 1 && 's'}
              </Button>
            </Level.Item>
          </Level.Right>
        </Level>
        <ErrorBoundary failsSilently>
          <CartSidebar
            popupProps={popup.popupProps}
            onClose={closeSidebar}
            onUpdate={(order) => {
              setTotalQuantity(order.totalQuantity)
            }}
            orderNumber={window.__USER__ && window.__USER__.currentOrder}
            orderToken={window.__USER__ && window.__USER__.orderToken}
            isReadOnly={window.location && window.location.pathname.indexOf('/checkout') > -1}
          />
        </ErrorBoundary>
      </React.Fragment>
    </ThemeProvider>
  )
}

export default CartButton
